import http from './http';

// Helper to extract a clean error message and throw
function handleError(error) {
  const msg = error?.response?.data?.message || error?.message || 'Request failed';
  throw new Error(msg);
}

// POST /api/v1/auth/login { email, password }
export async function login({ email, password }) {
  try {
    const res = await http.post('/api/v1/auth/login', { email, password });
    return { data: res.data };
  } catch (e) { handleError(e); }
}

// POST /api/v1/auth/logout { refreshToken }
export async function logout({ refreshToken }) {
  try {
    const res = await http.post('/api/v1/auth/logout', { refreshToken });
    return { data: res.data };
  } catch (e) { handleError(e); }
}

// POST /api/v1/auth/refresh { refreshToken }
export async function refresh({ refreshToken }) {
  try {
    const res = await http.post('/api/v1/auth/refresh', { refreshToken });
    return { data: res.data };
  } catch (e) { handleError(e); }
}

// Backward-compatible alias (previous code imported refreshToken())
export const refreshToken = refresh;

// POST /api/v1/auth/forgot-password { email }
export async function forgotPassword({ email }) {
  try {
    const res = await http.post('/api/v1/auth/forgot-password', { email });
    return { data: res.data };
  } catch (e) { handleError(e); }
}

// POST /api/v1/auth/verify-otp { email, otp }
export async function verifyOtp({ email, otp }) {
  try {
    const res = await http.post('/api/v1/auth/verify-otp', { email, otp });
    return { data: res.data }; // contains resetToken on success
  } catch (e) { handleError(e); }
}

// POST /api/v1/auth/reset-password { email, otp, newPassword }
export async function resetPassword({ email, otp, newPassword }) {
  try {
    const res = await http.post('/api/v1/auth/reset-password', { email, otp, newPassword });
    return { data: res.data };
  } catch (e) { handleError(e); }
}

// GET /api/v1/auth/health
export async function authHealth() {
  try {
    const res = await http.get('/api/v1/auth/health');
    return { data: res.data };
  } catch (e) { handleError(e); }
}

// (Optional retained) GET /api/v1/auth/profile
export async function getProfile() {
  try {
    const res = await http.get('/api/v1/auth/profile');
    return { data: res.data };
  } catch (e) { handleError(e); }
}
